import { checkStale, setCookie, getCookie } from "bh-mod";
import { getRoute } from 'bh-mod/components/layout/TopBar/Notifications/notificationHelper'

export default {
	data() {
		return {
			loading: false,
			timer: null,
			notifications: [],
			invitation: {
				id: '',
				show: false,
				instance: {},
				role: {},
				email: '',
				declineToken: '',
				notification: {}
			},
			invitations: [],
			currentInstance: null,
		}
	},

	computed: {
		currentURL() {
			return window.location.href.substring(0, window.location.href.indexOf(this.$tld) + 3);
		},

		currentApp() {
			return this.$store.state.theApp?.subdomain || 'admin'
		},
	},

	mounted() {
		this.setupVisibilityChangeHandler();
		this.currentInstance = getCookie('instance');
	},

	methods: {
		async getNotifications() {
			if (this.requested) return null;

			try {
				this.loading = true;
				let { data } = await this.$api.get("/notifications");

				this.requested = true;

				this.notifications = data.filter((notification) => {
					return !notification.deleted;
				}).map((notification) => {
					return getRoute(notification, this.$tld);
				});
			} catch (err) {
				this.requested = true;
				this.$toastError(err, 'Error while fetching notifications. Please try again.')
			} finally {
				this.loading = false;
			}
		},

		async remove(notification) {
			try {
				this.$api.delete("/notifications/" + notification.id);
				this.notifications = this.notifications.filter((x) => x.id != notification.id);
				if (notification.viewed == false) {
					this.unreadCount = Math.max(0, this.unreadCount - 1);
				}
			} catch (err) {
				if (!err || !err.response || !err.response.status || err.response.status !== 400) {
					this.$message.error(this.$err(err, 'Error while removing notification. Please try again.'))
				}
			}
		},

		deleteAll() {
			let self = this;
			this.$confirm({
				title: "Delete All Notifications",
				content: (h) => (
					<div>Do you want to delete all notifications?</div>
				),
				okText: "Delete",
				okType: "danger",
				cancelText: "Cancel",
				centered: true,
				onOk: () => {
					self.$api
						.get(`/notifications/clearall`)
						.then(({ data }) => {
							if (data.success) {
								self.notifications = [];
								self.unreadCount = 0;
							}
						}).catch(err => {
							self.$message.error(self.$err(err))
						});
				},
				onCancel() {
					console.log("Cancel");
				},
			});
		},

		async performAction(notification, action = null) {
			if (notification.route) {
				let instance = notification.instance;
				if (notification.setInstance && instance?.id) {
					setCookie("instance", instance.id);
					await this.$nextTick();
				}
				if (instance?.id === this.currentInstance && notification.route.startsWith(this.currentURL) && notification.redirect && !window.location.href.includes('localhost')) {
					this.$router.push(notification.redirect);
				} else {
					window.location.href = notification.route
				}
			} else if (notification.group === 'instance:invite') {
				let invitation = this.invitations.find(i => i.instance.id === notification.data.instance)
				if (!invitation) {
					await this.getInvitations();
					invitation = this.invitations.find(i => i.instance.id === notification.data.instance);

					if (!invitation) {
						this.$message.error('No Invitation found for the instance. Please refresh the page and try again!')
						return this.getNotifications()
					}
				}
				if (action === 'Accept') {
					this.accept(invitation, notification)
				} else if (action === 'Decline') {
					this.decline(invitation, notification);
				}
			}
			this.$api
				.put("/notifications/" + notification.id)
				.then(({ data }) => {
					if (data.success) {
						let index = this.notifications.findIndex(
							(x) => x.id == notification.id
						);
						if (index != -1) {
							this.notifications[index].viewed = true;
						}
					}
				}).catch(err => {
					this.$message.error(this.$err(err))
				});
		},

		async accept({ instance, role, id, email }, notification) {
			this.invitation = { instance, role, id, email }
			this.invitation.accept = true
			this.invitation.notification = notification

			this.$confirm({
				title: 'Accepting Invitation',
				content: h => <div class='mt-4'>This will accept the invitation to <strong>{instance.name}</strong> with the role of {role.name == 'bh_admin' ? 'Admin' : role.name}. Are you sure?</div>,
				okText: 'ACCEPT',
				okType: 'danger',
				cancelText: 'Cancel',
				centered: true,
				loading: this.loading,
				onOk: () => {
					this.confirmedAccept()
				}
			});
		},

		confirmedAccept() {
			this.loading = true;

			this.$api.put('/user-invites/accept/' + this.invitation.id).then(() => {
				this.$message.success('Congrats! You now have access to ' + this.invitation.instance.name, 3);
				this.markActionPerformed(this.invitation.notification);
			}).catch(() => this.$message.error('Error occurred while accepting invitation. Please try again!'))
		},

		async decline({ instance, role, id, email, declineToken }, notification) {
			this.invitation = { instance, role, id, email, declineToken }
			this.invitation.accept = true
			this.invitation.notification = notification

			this.$confirm({
				title: 'Declining Invitation',
				content: h => <div class='mt-4'>This will decline the invitation to <strong>{instance.name}</strong> with the role of {role.name == 'bh_admin' ? 'Admin' : role.name}. Are you sure?</div>,
				okText: 'DECLINE',
				okType: 'danger',
				cancelText: 'Cancel',
				centered: true,
				loading: this.loading,
				onOk: () => {
					this.confirmedDecline()
				}
			});
		},

		confirmedDecline() {
			this.loading = true;

			this.$api.get('/user-invites/decline/' + this.invitation.declineToken).then(() => {
				this.$message.warn(`You have declined the invitation for ${this.invitation.instance.name}.`);
				this.markActionPerformed(this.invitation.notification);
			}).catch((error) => {
				console.error('Error while declining invitation', error)
				this.$message.error('Error occurred while declining invitation. Please try again!')
			})
		},

		markActionPerformed(notification) {
			if (this.invitation.id && this.currentApp === 'admin') {
				this.updateInvitations(this.invitation.id);
			}

			this.$api
				.post(`notifications/${notification.id}/mark-action-performed`)
				.then(({ data }) => {
					this.requested = false;
					this.getNotifications()
					if (data.success) {
						let index = this.notifications.findIndex(
							(x) => x.id == notification.id
						);
						if (index != -1) {
							this.notification[index].viewed = true;
							this.notification[index].isActionPerformed = true;
						}
					}
					this.invitation = {
						id: '',
						show: false,
						instance: {},
						role: {},
						email: '',
						declineToken: '',
						notification: {}
					}
				}).catch((error) => {
					console.log('Error in notification action update', error)
				});
		},

		async getInvitations() {
			try {
				let { data } = await this.$api.get("/user-invites/me");
				this.invitations = data;
				if (this.currentApp === 'admin') {
					this.$store.commit('SET_INVITATIONS', data)
				}
			} catch (err) {
				if (!err || !err.response || !err.response.status || err.response.status !== 400) {
					this.$message.error(this.$err(err, 'Error while fetching invitations. Please try again.'))
				}
			}
		},

		updateInvitations(id) {
			let index = this.invitations.findIndex((x) => x.id == id);
			if (index != -1) {
				this.invitations.splice(index, 1);
				this.$store.commit('SET_INVITATIONS', this.invitations)
			}
			this.getInstances();
		},

		toEventGroup(notification, id) {
			let url = `https://contacts.bildhive.${this.$tld}/events/${id}`;

			if (notification.instance?.id) {
				if (getCookie("instance") == notification.instance.id && window.location.href.includes('contacts') && !window.location.href.includes('localhost')) {
					this.$router.push(`/events/${id}`);
				} else {
					setCookie("instance", notification.instance.id);
					window.location.href = url
				}
			}
		},

		setupVisibilityChangeHandler() {
			let self = this;
			document.addEventListener("visibilitychange", (e) => {
				if (document.visibilityState === "visible") {
					self.timer = setTimeout(() => {
						self.timer = null;
						let { isStale, onContinue } = checkStale();
						if (isStale && !self.isStaleAlready) {
							self.isStaleAlready = true;
							this.$confirm({
								title: "You are editing Multiple Projects at the same time",
								content: (h) => (
									<div>
										By Refreshing you will lose all unsaved
										data.
										<br /> By choosing to Continue, you will get
										to keep this project active.
									</div>
								),
								okText: "CONTINUE",
								cancelText: "REFRESH",
								onOk: () => {
									onContinue();
									self.isStaleAlready = false;
								},
								onCancel: () => {
									self.isStaleAlready = false;
									// Move user to the home page of the current app so if user is viewing some other page they don't see stale pages data
									const url = new URL(window.location.href);
									window.location.href = url.origin;
								},
							});
						}
					}, 3000);
				} else {
					if (self.timer) {
						clearTimeout(self.timer);
					}
				}
			});
		}
	},
}
